import api from './api';

// Servico helper para o sub-cadastro de "Integracoes de Importacao" da Ancora.
// Backend: AncorasImportacoesTitulosApisErpsController + ImportacoesTitulosApisErpsController.

/** Lista os perfis ERP ativos disponiveis para vincular (dropdown do modal). */
export async function consultarPerfisErpAtivos() {
  const response = await api.get('ImportacoesTitulosApisErps/ConsultarAtivos');
  return response?.data?.resposta || [];
}

/** Lista os vinculos (ancora x perfil ERP) de uma ancora. */
export async function consultarPorAncoraId(ancoraId) {
  const response = await api.get(
    `AncorasImportacoesTitulosApisErps/Consultar?ancoraId=${ancoraId}`,
  );
  return response?.data?.resposta || [];
}

/** Cria um novo vinculo. */
export async function adicionar(payload) {
  return api.post('AncorasImportacoesTitulosApisErps', payload);
}

/** Atualiza um vinculo existente. */
export async function atualizar(payload) {
  return api.put('AncorasImportacoesTitulosApisErps', payload);
}

/** Remove um vinculo. */
export async function apagar(id) {
  return api.delete(`AncorasImportacoesTitulosApisErps/${id}`);
}

/**
 * Consulta as lojas configuradas no Bluesoft para um vinculo existente.
 * Backend chama a Bluesoft usando as credenciais salvas do vinculo.
 * Retorna array de { lojaKey, nomeAbreviado, razaoSocial }.
 */
export async function consultarLojasBluesoft(id) {
  const response = await api.get(
    `AncorasImportacoesTitulosApisErps/${id}/LojasBluesoft`,
  );
  return response?.data?.resposta || [];
}

/** Converte CSV string ("12,15,42") em array de ints. Vazio/null -> []. */
export function lojasKeysToArray(csv) {
  if (!csv) return [];
  return String(csv)
    .split(',')
    .map((v) => v.trim())
    .filter((v) => v.length > 0)
    .map((v) => {
      const n = Number(v);
      return Number.isNaN(n) ? v : n;
    });
}

/** Converte array de ints/strings em CSV string. Array vazio -> "". */
export function arrayToLojasKeysCsv(arr) {
  if (!Array.isArray(arr)) return '';
  return arr.filter((v) => v !== null && v !== undefined && v !== '').join(',');
}

/** Converte array de ints/strings em CSV string ("1,2,3"). */
export function tipoDuplicataKeysToCsv(arr) {
  if (!Array.isArray(arr)) return '';
  return arr.filter((v) => v !== null && v !== undefined && v !== '').join(',');
}

/** Converte CSV string em array de ints. */
export function csvToTipoDuplicataKeys(csv) {
  if (!csv) return [];
  return String(csv)
    .split(',')
    .map((v) => v.trim())
    .filter((v) => v.length > 0)
    .map((v) => {
      const n = Number(v);
      return Number.isNaN(n) ? v : n;
    });
}

// Lista oficial extraida do OpenAPI do Bluesoft (DuplicataConsultarRequest.tipoDuplicataKey,
// especie=PAGAMENTO). Sao os codigos que o endpoint /api/financeiro/duplicatas aceita
// para uma consulta de contas a pagar. Ordenado pelos mais comuns primeiro.
export const TIPO_DUPLICATA_KEYS = [
  { id: 3, nome: 'Recebimento de Mercadorias' },
  { id: 14, nome: 'Transportadora de Carga' },
  { id: 15, nome: 'Despesa com Servico' },
  { id: 17, nome: 'Despesa com Imovel' },
  { id: 24, nome: 'Nota Fiscal de Servico' },
  { id: 25, nome: 'Nota Fiscal de Imovel' },
  { id: 26, nome: 'Devolucao de Venda a Cliente' },
  { id: 46, nome: 'Adiantamento de Pagamento' },
  { id: 2, nome: 'Imposto de Renda' },
  { id: 4, nome: 'Transferencia/Venda entre Lojas' },
  { id: 13, nome: 'GNRE' },
  { id: 19, nome: 'Transferencia de Valores' },
  { id: 20, nome: 'Complemento de Imposto' },
  { id: 22, nome: 'GARE-ICMS' },
  { id: 23, nome: 'Pagamento Cheque Devolvido' },
  { id: 27, nome: 'ISS Retido na Fonte (Tomador)' },
  { id: 28, nome: 'GPS - INSS Retido na Fonte' },
  { id: 29, nome: 'DARF - CSRF Retido na Fonte' },
  { id: 30, nome: 'DARF - IRRF Retido na Fonte' },
  { id: 31, nome: 'Pagamento de Funcionarios' },
  { id: 34, nome: 'Pensao Alimenticia' },
  { id: 35, nome: 'GPS - FUNRURAL' },
  { id: 36, nome: 'DARF - PIS' },
  { id: 37, nome: 'DARF - COFINS' },
  { id: 38, nome: 'DARF - CSLL' },
  { id: 39, nome: 'DARF - IRPJ' },
  { id: 40, nome: 'Precatorio' },
  { id: 41, nome: 'ISS Normal (Prestador)' },
  { id: 42, nome: 'GRF - FGTS' },
  { id: 43, nome: 'GARE-IPVA' },
  { id: 44, nome: 'Adiantamento de Funcionarios' },
  { id: 45, nome: 'DARF - IPI' },
  { id: 48, nome: 'Cartao Corporativo' },
  { id: 49, nome: 'Pagamento de Ferias de Funcionario' },
  { id: 50, nome: 'Rescisao de FGTS' },
  { id: 51, nome: 'GRU (Guia de Recolhimento da Uniao)' },
  { id: 52, nome: 'GRCSU - Contribuicao Sindical Urbana' },
  { id: 53, nome: 'REFIS - Recuperacao Fiscal' },
  { id: 54, nome: 'Pagamento 1a Parcela 13o Salario' },
  { id: 55, nome: 'Pagamento 2a Parcela 13o Salario' },
  { id: 56, nome: 'Pagamento de Rescisao de Contrato' },
  { id: 57, nome: 'Outros Tributos do Estado' },
  { id: 58, nome: 'DAS - Simples Nacional' },
  { id: 59, nome: 'GPS - INSS sobre Salarios' },
  { id: 60, nome: 'Pagamento de Dissidio' },
  { id: 61, nome: 'Pagamento de Rescisao sobre Dissidio' },
  { id: 62, nome: 'Pagamento de Repasse em Vendas de Servico' },
  { id: 63, nome: 'Pagamento de Compra de Imovel' },
  { id: 65, nome: 'Adiantamento a Socio' },
  { id: 66, nome: 'Convenio Funcionario com Outras Empresas' },
  { id: 68, nome: 'Outros Tributos Previdenciarios' },
  { id: 69, nome: 'DARF - INSS sobre Faturamento' },
  { id: 70, nome: 'Pagamento de Pro Labore' },
  { id: 71, nome: 'Pagamento de Custas de Cartorio' },
  { id: 72, nome: 'Emprestimos Concedidos a Pagar' },
  { id: 73, nome: 'Emprestimos Tomados a Pagar' },
  { id: 76, nome: 'Outros Tributos Federais' },
  { id: 77, nome: 'Complemento de Rescisao de Contrato' },
  { id: 78, nome: 'Complemento de FGTS' },
  { id: 80, nome: 'Encargos de Financiamento' },
  { id: 81, nome: 'Parcela de Financiamento' },
  { id: 83, nome: 'GRCA - Contribuicao Sindical Assistencial' },
  { id: 84, nome: 'Emprestimo entre Lojas' },
  { id: 86, nome: 'Vale Transporte de Funcionario' },
  { id: 87, nome: 'Vale Refeicao de Funcionario' },
  { id: 89, nome: 'Compensacao de Adiantamento de Cobranca' },
  { id: 91, nome: 'Duplicata de Migracao' },
  { id: 92, nome: 'Duplicata Agrupamento' },
  { id: 93, nome: 'Comissao de Vendas' },
  { id: 94, nome: 'DARE - Documento de Arrecadacao de Receitas' },
  { id: 95, nome: 'Comissao de Entregas' },
  { id: 96, nome: 'Outros Tributos Municipais' },
];

// Compat retro: alguns componentes ainda esperam so os IDs. Deriva do TIPO_DUPLICATA_KEYS.
export const TIPO_DUPLICATA_KEYS_PLACEHOLDER = TIPO_DUPLICATA_KEYS.map((t) => t.id);

/** Retorna o nome legivel de um tipoDuplicataKey. Se nao achar, devolve "Tipo N". */
export function nomeTipoDuplicata(id) {
  const t = TIPO_DUPLICATA_KEYS.find((x) => x.id === Number(id));
  return t ? t.nome : `Tipo ${id}`;
}
